import { Component, Inject, OnInit } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { Router } from "@angular/router";
import { forkJoin, map, Observable } from "rxjs";
import { DocumentExchangeCategory } from "src/app/classes/document-exchange";
import { Environment } from "src/app/classes/environment";
import { Group } from "src/app/classes/fileInfo";
import { Section } from "src/app/classes/section";
import { User } from "src/app/classes/user";
import { DocumentExchangeService } from "src/app/services/document-exchange.service";
import { FileService } from "src/app/services/file.service";
import { SectionService } from "src/app/services/section.service";
import { UserService } from "src/app/services/user.service";
import { MemberEditorComponent } from "../editors/member-editor.component";


@Component( {
    selector: "member-creator",
    templateUrl: "./member-creator.component.html",
    standalone: true,
    imports: [ MemberEditorComponent, MatProgressSpinnerModule, MatIconModule ]
} )
export class MemberCreatorComponent implements OnInit {


    bLoading = true;
    bError = false;

    sections: Section[] = [];
    groups: Group[] = [];
    documentExchangeCategories: DocumentExchangeCategory[] = [];
    users: User[] = [];
    usernames: { [key:string]: string } = {};

  
    constructor(
        private fileService: FileService,
        private userService: UserService,
        @Inject( "environment" ) public environment: Environment,
        private sectionService: SectionService,
        private documentExchangeService: DocumentExchangeService,
        private router: Router
    ) {}

    
    ngOnInit(): void {

        const obss: Observable<boolean>[] = [
            this.fileService.getGroups().pipe( 
                map( groups => {
                    this.groups = groups;
                    return true;
                } )
            ),
            this.userService.getAll().pipe(
                map( users => {

                    // looking for users for don't have yet a Mitglied and who are not admin
                    this.users = users
                        .filter( u => !u.mitgliedId )
                        .filter( u => !u.gruppen || !u.gruppen.includes( 'ADMIN' ) );
                    
                    for( let user of users ) {
                        const arr: string[] = [];
                        if( user.ebeVorname ) arr.push( user.ebeVorname );
                        if( user.ebeName ) arr.push( user.ebeName );
                        this.usernames[ user.ebeId ] = ( arr.join( " " ) || user.ebeId );
                    }
    
                    return true;
                    
                } )
            )
        ];
        if( this.environment.features.sparten ) {
            obss.push( this.sectionService.getAll().pipe(
                map( sections => {
                    this.sections = sections;
                    return true;
                })
            ) );
        }
        if( this.environment.features.austausch ) {
            obss.push( this.documentExchangeService.getDocumentExchangeCategories().pipe(
                map( deCategories => {
                    if( !deCategories ) return false;
                    this.documentExchangeCategories = deCategories;
                    return true;
                })
            ) );
        }


        forkJoin( obss ).subscribe( results => {

            this.bLoading = false;
            for( const result of results ) {
                if( !result ) this.bError = true;
            }

        });
        

    }

    creationDone( e: any ) {
        this.router.navigate( [ 'Mitgliederverwaltung' ] );
    }

}
